import { RiArrowDownSLine } from "react-icons/ri";
import { MdLanguage } from "react-icons/md";
import { useContextTranslate } from "./ContextProvider";
import { useClose } from "../../Tools/APIs";

function Translation() {
  const { open, setOpen, mouse } = useClose(false);
  const { reverse, changeLanguage, changeLanguage2 } = useContextTranslate();
  return (
    <div ref={mouse}>
      <div className="relative cursor-pointer" onClick={() => setOpen(!open)}>
        <div
          className={`flex items-center justify-center gap-1 ${
            reverse ? "flex-row-reverse" : ""
          }`}
        >
          <MdLanguage color="#fff" className="" size={30} />
          <RiArrowDownSLine
            color="#fff"
            size={20}
            className={`${
              open ? "rotate-180 transition-all" : "rotate-0 transition-all"
            }`}
          />
        </div>
        <ul
          className={`${
            open
              ? "flex-col absolute top-9 rounded-xl text-center bg-gray-500 text-white z-50 w-24"
              : "hidden"
          } ${reverse ? "-left-4" : "-right-4"}`}
        >
          <li
            className="border-b pb-1 pt-2 rounded-t-xl cursor-pointer hover:bg-[#FCD68B] hover:text-[#375499]"
            onClick={changeLanguage2}
          >
            العربية
          </li>
          <li
            className="pt-1  pb-2 rounded-b-xl cursor-pointer hover:bg-[#FCD68B] hover:text-[#375499]"
            onClick={changeLanguage}
          >
            English
          </li>
        </ul>
      </div>
    </div>
  );
}
export default Translation;
